export default {
  submit: 'Check',
  loading: 'Loading...',
  tokenInfoTitle: 'Token Profile',
  tokenDetectionTitle: 'Security Detection',
  baseInfo: 'Profile Summary',
  projectSymbol: 'Token Symbol',
  projectName: 'Project',
  contractAddress: 'Contract',
  contractOwner: 'Contract Owner',
  website: 'Official Site',
  socialInfo: 'Social Profiles',
  more: 'more',
  releaseInfo: 'Token Overview',
  releaseTotal: 'Total Supply',
  releaseTime: 'Issue Time',
  securityInfo: 'Security Info',
  moreSecurityInfo: 'View more security details',
  detection: 'Check',
  network: 'choose network',
  detectionDesc:
    "The security detection is for reference only base on the on-chain data analysis. It doesn't mean that the data is 100% correct. Please always do your own researches and do your own risks. TokenPocket will commit to provide more useful data to users.",
  securityOverview: 'Security Overview',
  risky: 'Risky Items',
  attentionTip: 'Attention Items',
  contractCreator: 'Creator',
  circulation: 'Circulation',
  tradingSecurityReport: 'Trading Security Report',
  buy_tax: 'Buy Tax',
  sell_tax: 'Sell Tax',
  unknown_tax: 'unknown',
  contractSecurityReport: 'Contract Security Report',
  trade_0_text1: 'This seems not like a honeypot',
  trade_0_text2: "Trading tax can't be modified",
  trade_0_text3: "Trading can't be suspended",
  trade_0_text4: 'No blacklist feature',
  trade_0_text5: 'No whitelist feature',
  trade_0_text6: 'No anti whale feature',
  trade_0_text7: 'Can buy',
  trade_0_text8: 'Can sell all',
  trade_0_text9: 'Has not trading cool down',
  trade_0_text10: 'Cannot be able to modify slippage by personal',
  trade_0_text11: 'No functions to modify maximum token transfer or trade',

  trade_1_text1: 'This is a honeypot!',
  trade_1_text2: 'Trading tax can be modified',
  trade_1_text3: 'Trading can suspended',
  trade_1_text4: 'Has blacklist feature',
  trade_1_text5: 'Has whitelist feature',
  trade_1_text6: 'Has anti whale feature',
  trade_1_text7: 'Cannot buy',
  trade_1_text8: 'Cannot sell all',
  trade_1_text9: 'Has trading cool down',
  trade_1_text10: 'Be able to modify slippage by personal',
  trade_1_text11: 'Have function to modify maximum token transfer or trade',

  trade_2_text1: 'Owner transferred, cannot pause transfer',
  trade_2_text2: 'Owner transferred, cannot set trading cooldown',
  trade_2_text3: 'Owner transferred, cannot set slippage',
  trade_2_text4: 'Owner transferred, cannot update maximal token position',

  trade_token_status_text1: "It's marked as phishing or scaming token",

  airdropScam: 'It is an airdrop scam',
  fakeToken: 'It is a fake token',

  contract_0_text1: 'Contract source code verified',
  contract_0_text2: 'No proxy contracts',
  contract_0_text3: 'No mint features',
  contract_0_text4: 'Owner cannot change balance',
  contract_0_text5: 'No hidden owners',
  contract_0_text6: 'Cannot take back ownership',
  contract_0_text7: 'Cannot be able to self destructed',
  contract_0_text8: 'There is no external call on this contract',

  contract_1_text1: 'Contract source code not verified',
  contract_1_text2: 'It has a proxy contract',
  contract_1_text3: 'It has a mint feature',
  contract_1_text4: 'Owner can change balance',
  contract_1_text5: 'Has a hidden owner',
  contract_1_text6: 'Can take back ownership',
  contract_1_text7: 'Be able to self destructed, assets can be empty',
  contract_1_text8: 'There is an external call on this contract',

  contract_2_text1: 'Owner transferred, cannot mint more token',
  contract_2_text2: 'Owner transferred, cannot modify balance',

  copySuccess:
    "Copied. Attentions, the address you just copied is a contract address, please don't transfer any assets to this address, or you will lose your assets!",
  report: 'report',
  placeholder: 'Input token contract address',

  errorContract:
    'Query failed, please confirm if the contract address is correct',
  errorData: 'Cannot find the data, please try again later',
  understood: 'Understood',
  copySuccess2: 'Successfully copied',
  copySuccess3: 'Link copied successfully',

  is_honeypot:
    'Honeypot Token: a worthless token cannot be resold when it is bought.',
  locked: 'Locked',
  smartContract: 'Smart Contract',

  liquidityPool: 'Liquidity Pool',
  poolInfo: 'Pool Info',
  lockedPercent: 'Percentage of LP locked',
  amm: 'AMM',
  pair: 'Pair',
  amount: 'Amount',
  liquidity: 'Liquidity',

  share_report: 'Share Report',
  check_report: 'Check Report',
  contract_ownership: 'Owner has been discarded',
  chain_not_found: 'Chain not found～',
  settings: 'Settings',
  languages: 'Languages',
  search_placeholder: 'Enter the network name',
  darkmode: 'Dark Mode',

  tokenHolders: 'Token Holders',
  top10Holders: 'Top 10 holders',
  LPHolders: 'LP Holders',
  holdersNumber: 'Holders number',

  SOL: {
    ownerProgram: 'Owner Program',
    ownerProgram_1: 'Token Program',
    ownerProgram_2: 'Token 2022 Program',
    current_fee_rate_1: 'Current transfer tax',
    current_fee_rate_2: 'Maximum tax amount',
    current_fee_rate_3: 'Current transfer tax: unknown',
    scheduled_fee_rate:
      'Transaction tax will automatically change to {tax}% after epoch {epoch1}. Current epoch: {epoch2}',
    scheduled_fee_rate_1:
      'The transaction tax rate has been automatically changed to {tax}% at epoch {epoch1}. current epoch: {epoch2}',

    trade_0_text1: 'The token is fully ready for use',
    trade_0_text2: 'The token is transferable',
    trade_0_text3: 'The creator is not a malicious address',
    trade_0_text4: 'There are no external hooks in the token program',
    trade_0_text5: 'The token is famous and trustworthy',

    trade_1_text1: 'The token is newly created and not ready for use.',
    trade_1_text4: 'There are external hooks in the token program',
    trade_1_text5: 'The token is not famous and trustworthy',

    trade_2_text1: 'The token was frozen',
    trade_2_text2: 'The  token is non-transferable',
    trade_2_text3: 'The creator is a malicious address',
    trade_2_text4:
      'There are external hooks in the token program, and the hook contract is malicious!',

    contract_0_text1: "The token's metadata is not mutable",
    contract_0_text2: 'The token is not mintable',
    contract_0_text3: 'The developer can not block users from trading',
    contract_0_text4: 'The developer can not close the token programme',
    contract_0_text5: "The transfer fee of the token can't be upgraded",
    contract_0_text6: 'The default account state is not upgradable',
    contract_0_text7: 'Developer  can not change balance',
    contract_0_text8: 'The transfer hook is not upgradeable',

    contract_1_text1:
      "The token's metadata is mutable, but has no authority address",
    contract_1_text2: 'The token is mintable',
    contract_1_text3: 'The developer can block users from trading',
    contract_1_text5: 'The transfer fee of the token can be upgraded',
    contract_1_text6: 'The default account state is upgradable',
    contract_1_text8: "The transfer hooks can't be upgradeable",

    contract_2_text1:
      "There is an address with permission to modify the token's metadata",
    contract_2_text4: 'The developer can close the token programme at any time',
    contract_2_text7: 'Developer can change balance',

    transfer_hook: 'Hook may block user from trading',
    transfer_hook_1: 'External hook contract:',
    metadata_mutable: 'Authority address:',
    trading: 'Basic Info Security Report',
    contract: 'Token Function and Risk Analysis',
  },

  tokenSecurityData: {
    trade_0_text1: 'This seems not like a honeypot',
    trade_0_text2: "Trading tax can't be modified",
    trade_0_text3: "Trading can't be suspended",
    trade_0_text4: 'No blacklist feature',
    trade_0_text5: 'No whitelist feature',
    trade_0_text6: 'No anti whale feature',
    trade_0_text7: 'Can buy',
    trade_0_text8: 'Can sell all',
    trade_0_text9: 'Has not trading cool down',
    trade_0_text10: 'Cannot be able to modify slippage by personal',
    trade_0_text11: 'No functions to modify maximum token transfer or trade',

    trade_1_text1: 'This is a honeypot!',
    trade_1_text2: 'Trading tax can be modified',
    trade_1_text3: 'Trading can suspended',
    trade_1_text4: 'Has blacklist feature',
    trade_1_text5: 'Has whitelist feature',
    trade_1_text6: 'Has anti whale feature',
    trade_1_text7: 'Cannot buy',
    trade_1_text8: 'Cannot sell all',
    trade_1_text9: 'Has trading cool down',
    trade_1_text10: 'Be able to modify slippage by personal',
    trade_1_text11: 'Have function to modify maximum token transfer or trade',

    trade_2_text1: 'Owner transferred, cannot pause transfer',
    trade_2_text2: 'Owner transferred, cannot set trading cooldown',
    trade_2_text3: 'Owner transferred, cannot set slippage',
    trade_2_text4: 'Owner transferred, cannot update maximal token position',

    trade_token_status_text1: "It's marked as phishing or scaming token",

    airdropScam: 'It is an airdrop scam',
    fakeToken: 'It is a fake token',

    contract_0_text1: 'Contract source code verified',
    contract_0_text2: 'No proxy contracts',
    contract_0_text3: 'No mint features',
    contract_0_text4: 'Owner cannot change balance',
    contract_0_text5: 'No hidden owners',
    contract_0_text6: 'Cannot take back ownership',
    contract_0_text7: 'Cannot be able to self destructed',
    contract_0_text8: 'There is no external call on this contract',

    contract_1_text1: 'Contract source code not verified',
    contract_1_text2: 'It has a proxy contract',
    contract_1_text3: 'It has a mint feature',
    contract_1_text4: 'Owner can change balance',
    contract_1_text5: 'Has a hidden owner',
    contract_1_text6: 'Can take back ownership',
    contract_1_text7: 'Be able to self destructed, assets can be empty',
    contract_1_text8: 'There is an external call on this contract',

    contract_2_text1: 'Owner transferred, cannot mint more token',
    contract_2_text2: 'Owner transferred, cannot modify balance',

    buy_tax: 'Buy Tax {tax}',
    sell_tax: 'Sell Tax {tax}',
    unknown_buy_tax: 'Buy tax unknown',
    unknown_sell_tax: 'Sell tax unknown',
    unknown_tax: 'unknown',
    is_honeypot: 'Honeypot Token',
    info: 'Security Info',

    desc: 'The security check results are for reference only and do not guarantee absolute accuracy, nor do they constitute any form of endorsement or investment advice. Please do your own research before trading any token.',
    hightRiskToken:
      'Flagged by the community as a high-risk token. Please be cautious.',
    liquidityLow:
      'Liquidity ≤ $5K. Trading this token may result in asset loss.',
    scanOverview: 'Scan Overview',
    taxRate: 'Tax Rate',
    testItems: 'Check Items',
    buyTax: 'Buy Tax',
    sellTax: 'Sell Tax',
    highRisk: 'High Risk',
    mediumRisk: 'Medium Risk',
    is_open_source: 'Open Source Contract',
    is_open_source_tip:
      'Open-source contracts allow the source code to be viewed on-chain. If not open-source, the contract authenticity cannot be verified.',
    is_proxy: 'Proxy Contract',
    is_proxy_tip:
      'Proxy contracts allow the team to modify core contract logic, posing the risk of tampering.',
    is_mintable: 'Mintable',
    is_mintable_tip:
      'Minting allows the project team to increase total supply arbitrarily, which may cause inflation or value dilution.',
    owner_change_balance: 'Owner Can Modify Balances',
    owner_change_balance_tip:
      'If the owner can modify user balances, assets may be directly manipulated or wiped.',
    can_take_back_ownership: 'Ownership Can Be Reclaimed',
    can_take_back_ownership_tip:
      'Contracts that allow reclaiming ownership enable the project team to regain control, increasing the risk of changes or interference.',
    hidden_owner: 'Hidden Owner',
    hidden_owner_tip:
      'A hidden owner address indicates undisclosed controllers who may bypass standard checks.',
    is_honeypot_tip:
      'Honeypot tokens typically allow buying but restrict selling, potentially locking your funds permanently.',
    transfer_pausable: 'Transfer Pausable',
    transfer_pausable_tip:
      'The ability to pause transfers allows the project team to halt trading at any time, preventing you from selling.',
    cannot_buy: 'Cannot Buy',
    cannot_buy_tip:
      'Tokens that cannot be bought indicate potential fraud risks.',
    cannot_sell_all: 'Cannot Sell All',
    cannot_sell_all_tip:
      'Sell limits prevent selling all tokens at once, locking part of your assets.',
    trading_cooldown: 'Trading Cooldown',
    trading_cooldown_tip:
      'Cooldown mechanisms enforce a delay between trades, limiting trading.',
    is_anti_whale: 'Anti-Whale Mechanism',
    is_anti_whale_tip:
      'Anti-whale mechanisms limit transaction size or holdings, which may affect normal trading.',
    slippage_modifiable: 'Tax Rate Modifiable',
    slippage_modifiable_tip:
      'Contracts that allow tax modification enable sudden fee increases, causing trading losses.',
    is_blacklisted: 'Blacklist Function',
    is_blacklisted_tip:
      'Blacklist functions allow blocking specific addresses from trading.',
    is_whitelisted: 'Whitelist Function',
    is_whitelisted_tip:
      'Whitelist mechanisms allow only specific addresses to trade, excluding regular addresses.',
    anti_whale_modifiable: 'Anti-Whale Settings Modifiable',
    anti_whale_modifiable_tip:
      'Modifiable anti-whale settings allow owners to adjust limits, restricting trades.',
    is_true_token: 'True Token',
    is_true_token_tip:
      'Fake tokens may imitate official names or logos to deceive users.',
    is_airdrop_scam: 'Airdrop Scam',
    is_airdrop_scam_tip:
      'Airdrop scams disguise as giveaways to trick users into granting approvals and stealing assets.',
    selfdestruct: 'Self-Destruct',
    selfdestruct_tip:
      'Self-destruct functions allow the team to destroy the contract, causing permanent asset loss.',
    external_call: 'External Call Risk',
    external_call_tip:
      'External calls mean reliance on other contracts, which may introduce risks if compromised.',
    personal_slippage_modifiable: 'Personal Slippage Modifiable',
    personal_slippage_modifiable_tip:
      "The owner's authority means they can set a special tax rate for a specified address to prevent transactions.",
    trust_list: 'Trusted List',
    can_self_destruct: 'Self-Destruct',
    can_self_destruct_tip:
      'Self-destruct functions allow the team to destroy the contract, causing permanent asset loss.',
    major_holder_ratio: 'High Concentration of Major Holders',
    major_holder_ratio_tip:
      'If the top 20 addresses hold an high percentage of token, a few large holders can easily manipulate the price or liquidity, affecting market.',
    has_external_calls: 'External Call Risk',
    has_external_calls_tip:
      'External calls mean reliance on other contracts, which may introduce risks if compromised.',
    buyTaxTip:
      'High buy tax may indicate hidden fees or traps, reducing received tokens.',
    sellTaxTip:
      'High sell tax may significantly reduce proceeds or prevent full selling.',
  },

  solTokenSecurityData: {
    fee_in_basis_points: 'Fee',
    fee_in_basis_points_tip:
      'High fees may consume a large amount of funds in each transaction, causing significant losses when buying or selling tokens, and affecting asset liquidity and tradability',
    freezable: 'Trading Freeze',
    freezable_tip:
      'The trading freeze feature allows the contract to block all buy and sell operations under certain conditions, which may cause users to be unable to transfer out or sell tokens when needed',
    transfer_fee_upgradable: 'Transfer Fee Rate Modifiable',
    transfer_fee_upgradable_tip:
      'A high transfer fee rate increases your buying cost and affects your selling proceeds, significantly reducing your actual returns.Contracts that can adjust the transfer fee rate may also bring additional risks, such as raising the fee to 100% to prevent selling',
    interest_rate: 'Interest Rate Mechanism',
    interest_rate_tip:
      'Tokens with an interest rate mechanism have more complex value calculations and more complicated smart contract logic, increasing the possibility of code vulnerabilities and making token value harder to evaluate',
    rate_authority: 'Can Interest Rate Be Changed',
    rate_authority_tip:
      'There is an address that can modify the interest rate, meaning the token’s interest rate may be changed at any time, which could result in asset losses.',
    liquidity_control: 'Is Liquidity Distribution Normal',
    liquidity_control_tip:
      'If most liquidity is controlled by one or a few addresses, they can withdraw funds from the liquidity pool at any time, causing the token to lose tradability and the price to drop to zero',
    major_holders_ratio: 'Is Holder Distribution Normal',
    major_holders_ratio_tip:
      'If the top holders hold too many tokens, they can easily dump large amounts on the market (crash the price), or manipulate the market by pumping and selling',
    initial_distribution: 'Is Initial Distribution Normal',
    initial_distribution_tip:
      'Check whether the distribution at the token’s inception was fair. If the initial distribution is highly concentrated, it often indicates the project reserved a large amount of tokens for later selling—an “pre-mine” trap',
    transfer_fee_authority: 'Transfer Fee Authority Exists',
    transfer_fee_authority_tip:
      'If this authority exists, an address can arbitrarily change transfer fees, increasing users’ transaction costs, and even effectively lock assets through extremely high fees',
    transfer_fee_extension: 'Transfer Fee Extension Exists',
    transfer_fee_extension_tip:
      'The token has a built-in transfer fee feature, where fees may be automatically deducted on every transfer. If there is also authority to change the fee, the risk is higher.',
    confidential_transfer_extension: 'Confidential Transfer Extension Exists',
    confidential_transfer_extension_tip:
      'This feature encrypts transfer amounts, preventing you from viewing the exact transfer amounts of this token on-chain',
    interest_bearing_token_extension: 'Interest-Bearing Token',
    interest_bearing_token_extension_tip:
      'An interest-bearing token refers to a token with an interest rate mechanism. Its smart contract logic is more complicated, increasing the possibility of code vulnerabilities and making token value harder to evaluate',
    default_account_state: 'Is Token Initialization State Normal',
    default_account_state_tip:
      'The token initialization state indicates whether it is a live deployed version. If the token has not been fully activated, there may be risks of replacement or modification, or even trading freezes',
    non_transferable: 'Is Token Transferable',
    non_transferable_tip:
      'Non-transferable tokens restrict transfers between addresses, or allow only internal contract transfers, which may prevent your assets from being freely traded',
    non_transferable_token_extension: 'Is Token Transferable',
    non_transferable_token_extension_tip:
      'Non-transferable tokens restrict transfers between addresses, or allow only internal contract transfers, which may prevent your assets from being freely traded',
    creators: 'Creator Is a Malicious Address',
    creators_tip:
      'If the contract creator is a malicious address, there may be scam or malicious operation risks such as lockups or fee manipulation',
    transfer_hook: 'External Program Exists',
    transfer_hook_warning_tip:
      'Having an external program means the contract can be called and controlled by an external program, which may block trading',
    transfer_hook_danger_tip:
      'Having an external program means the contract can be called and controlled by an external program, which may block trading, and this token has malicious external programs and addresses:',
    transfer_hook_extension: 'External Program Exists',
    transfer_hook_extension_tip:
      'Having an external program means the contract can be called and controlled by an external program, which may block trading',
    trusted_token: 'Trusted Token',
    trusted_token_tip:
      'This token is listed on a third-party trusted list. However, its trustworthiness is not guaranteed. Please ensure this is a token you trust before trading.',
    metadata_mutable: 'Token Metadata Can Be Modified',
    metadata_mutable_warning_tip:
      'Token metadata can be modified, meaning the token name, symbol, or decimals can be changed. Currently, the metadata is mutable, but no address has the permission to change it',
    metadata_mutable_danger_tip:
      'Token metadata can be modified, meaning the token name, symbol, or decimals can be changed. Currently, the metadata is mutable, and there is an address with permission to change it',
    mintable: 'Mintable',
    mintable_tip:
      'Minting allows the project team to increase total supply arbitrarily, which may cause inflation or value dilution',
    mint_authority: 'Mintable',
    mint_authority_tip:
      'Minting allows the project team to increase total supply arbitrarily, which may cause inflation or value dilution',
    closable: 'Closable',
    closable_tip:
      'The close function allows the project team to close the token at any time, which may cause asset loss',
    closing_mint_extension: 'Closable',
    closing_mint_extension_tip:
      'The close function allows the project team to close the token at any time, which may cause asset loss',
    default_account_state_upgradable: 'Account State Upgradable',
    default_account_state_upgradable_tip:
      'Upgradeable contracts mean developers can modify underlying logic. While providing flexibility, it also introduces backdoor and security risks',
    balance_mutable_authority: 'Modify Balance',
    balance_mutable_authority_tip:
      'If developers can modify balances, they can directly change account balances, which may lead to risks of your assets being arbitrarily increased, reduced, or wiped',
    transfer_hook_upgradable: 'External Program Upgradable',
    transfer_hook_upgradable_tip:
      'If the external program has upgrade authority, developers or external controllers can replace or modify the program logic at any time, potentially introducing malicious code, altering trading rules, or causing asset risks',
    token_launch_time: 'New Token',
    token_launch_time_tip: 'This is a newly created token',
    withdraw_withheld_authority: 'Withheld Withdrawal Authority Exists',
    withdraw_withheld_authority_tip:
      'This is an authority that can withdraw withheld tokens (e.g., transfer fees) from all accounts, which may be abused to extract user funds',
    permanent_delegate_extension: 'Permanent Delegate Extension Exists',
    permanent_delegate_extension_tip:
      'An address with this authority can destroy or transfer this token from any address at any time, effectively having full control over your assets',
    scheduled_fee_rate: 'Is Transfer Fee Adjustable',
    scheduled_fee_rate_tip:
      'Adjustable transfer fees mean developers can change the fee rate at any time. Fees may suddenly increase, making it impossible to sell or significantly reducing your proceeds, bringing the risk of asset loss',
    scheduled_fee_rate_tip_1:
      'The transfer fee will change to {tax}% at epoch {epoch1}. Current epoch: {epoch2}',
    scheduled_fee_rate_tip_2:
      'The transfer fee has changed to {tax}% at epoch {epoch1}. Current epoch: {epoch2}',
    scheduled_fee_rate_tip_future:
      'and will be changed to {tax} at epoch {epoch2}.',
    scheduled_fee_rate_tip_past:
      'The transfer fee has changed to {tax}% at epoch {epoch1},',
    scheduled_fee_rate_tip_current_epoch: 'Current epoch: {epoch2}',
  },

  testingParty: 'Audit Provider',
  currentFee: 'Current Buy/Sell Tax',
  tokenSecurityTip:
    'Due to modifiable contract parameters, this security information is for reference only',
  unknown: 'Unknown',
};
